/* eslint-disable no-console */
import { useCustomerContext } from 'contexts';
import { useAuth } from 'hooks';
import { ComponentType } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Auth, customerType } from 'types';
import { loadState } from 'utils';

function withAuth<T extends JSX.IntrinsicAttributes>(
  Component: ComponentType<T>,
  roles?: string[],
  customer?: customerType,
  // redirect?: To,
) {
  return (props: T) => {

    const { user, roles: userRoles, flatMenu } = useAuth();
    const { name } = useCustomerContext();
    const auth = loadState<Auth>('auth');
    const location = useLocation();

    const hasRoutePermission = (): boolean => {
      if (!flatMenu || !location?.pathname) return false;


      const currentPath = location.pathname;

      const publicRoutes = [
        '/pages/home',
        '/pages/account/change_password',
        '/dashboard',
        '/',
      ];

      const publicPatterns = ['/pages/account'];

      if (publicRoutes.includes(currentPath)) return true;
      if (publicPatterns.some(pattern => currentPath.startsWith(pattern))) return true;

      const menuLinks = flatMenu
        .map(item => item?.link)
        .filter(link => link && typeof link === 'string' && link.trim() !== '');

      if (menuLinks.includes(currentPath)) return true;

      // Permitir sub-rutas basándose en patrones comunes de la aplicación
      return menuLinks.some(link => {
        if (!currentPath.startsWith(link + '/')) return false;

        const subPath = currentPath.substring(link.length + 1);
        const segments = subPath.split('/');

        if (!segments[0]) return false;

        // Patrones permitidos para sub-rutas DENTRO del mismo permiso:
        const allowedPatterns = [
          /^\d+$/,                    // IDs numéricos: /123
          /^(create|edit)$/,   //CRUD 
          /^(regex|bot|services)$/,           // exceptions/regex, automationmanager/123/bot
          /^cp$/                      // Parámetro especial: reportes/pendientes/cp/:valor
        ];

        return allowedPatterns.some(pattern => pattern.test(segments[0]));
      });
    };

    const shouldRedirect =
      !user ||
      !auth ||
      (roles && !userRoles?.some((role) => roles.includes(role))) ||
      (customer && name !== customer) ||
      !hasRoutePermission();

    if (shouldRedirect)
      return <Navigate to="/login" state={{ from: location }} replace />;

    return <Component {...props} />;
  };
}

export default withAuth;
